var map = {
	"./bn/main.yml": 32,
	"./ca/main.yml": 33,
	"./cy/main.yml": 34,
	"./de/main.yml": 35,
	"./en/main.yml": 36,
	"./eo/main.yml": 37,
	"./es/main.yml": 38,
	"./eu/main.yml": 39,
	"./fr/main.yml": 40,
	"./hr/main.yml": 41,
	"./it/main.yml": 42,
	"./oc/main.yml": 43,
	"./pl/main.yml": 44,
	"./pt_BR/main.yml": 45
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;